var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.Title || 'No Data'))]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.Description || 'Please connect your wallet, and Ceramic/IPFS.'))]),_c('wallet-connector')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }